export default "__VITE_ASSET__CdWfB9E7__"